import { render, staticRenderFns } from "./AssetDetailContent.vue?vue&type=template&id=6cf95833"
import script from "./AssetDetailContent.vue?vue&type=script&lang=js"
export * from "./AssetDetailContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports